import { createSlice } from "@reduxjs/toolkit";

// Define initial state
const initialState = {
  globalLoadMoreClicked: false,
};

// Create app slice
const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    setGlobalLoadMoreClicked: (state) => {
      state.globalLoadMoreClicked = true;
    },
    resetGlobalLoadMoreClicked: (state) => {
      state.globalLoadMoreClicked = false;
    },
  },
});

// Export actions and reducer
export const { setGlobalLoadMoreClicked, resetGlobalLoadMoreClicked } =
  appSlice.actions;
export default appSlice.reducer;
